The value of `HiringOrganization.id` for the requested object.
